import { createFrontendMemberRoute } from "@flow/frontend/member/FrontendMemberRoute";
import * as Safe from "safe-portals";
import { TargetVideoLandingPageComponent } from "./TargetVideoLandingPageComponent";

createFrontendMemberRoute({
  urlPrefix: "send-a-message/submission-video",
  args: Safe.obj({
    submission_guid: Safe.uuid,
  }),
  component: (props) => {
    return <TargetVideoLandingPageComponent {...props} />;
  },
});
